import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { GlobalFilter } from 'pages/components/GlobalFilter';
import { useRef, useState } from 'react';
import { ModeTable } from './components/ModeTable';
import { formFilter } from './form';
import { filterSchema } from './schema';
import { VehicleFilter } from './types';

export const Vehicles = () => {
  const [filter, setFilter] = useState<VehicleFilter>({});
  const refModeTable = useRef<any>(null);

  const setCurrentFilters = (value: any) => {
    setFilter({ ...value });
    refModeTable?.current?.resetPage?.();
  };

  const handleOpenCreate = () => {
    const event = new CustomEvent('openVehicleCreateModal');
    window.dispatchEvent(event);
  };

  return (
    <Box
      as={motion.div}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      height="100%"
    >
      <Flex justify="space-between" align="center" mb={6}>
        <Heading as="h2" size="md" color="gray.700">
          Veículos
        </Heading>
        <Button colorScheme="primary" onClick={handleOpenCreate}>
          Novo Veículo
        </Button>
      </Flex>

      <GlobalFilter
        schema={filterSchema}
        form={formFilter}
        actionFilter={setCurrentFilters}
        loadingFilter={false}
        title="Filtrar Veículos"
      />

      {/* Tabela */}
      <Box mt={6}>
        <ModeTable filter={filter} ref={refModeTable} />
      </Box>
    </Box>
  );
};
